

















































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState, mapActions, mapGetters } from 'vuex';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxBox } from 'devextreme-vue/box';
import { DxCheckBox, DxSelectBox, DxLookup, DxNumberBox, DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel, DxButtonItem, DxTabbedItem, DxTab } from 'devextreme-vue/form';
import employeesRepository from '@/modules/employees/employeesRepository';
import {
  Address,
  ITunnelGroup,
  ProjectsClient,
  ProjectUpdateCommand,
  ProjectWarrantySettings,
  TemplateCompanyPrefixDto,
  TunnelGroupsClient,
  ZipClient,
  EmployeesClient,
  Employee,
BillingType,
} from '@/data/web-api-client';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import ConfirmProjectOnHoldPopup from '@/components/projects/ConfirmProjectOnHoldDialog.vue';
import ConfirmRevertProjectOnHoldPopup from '@/components/projects/ConfirmRevertProjectOnHoldPopup.vue';

@Component({
  components: {
    DxCheckBox,
    DxSelectBox,
    DxLookup,
    DxNumberBox,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxTabbedItem,
    DxTextArea,
    DxScrollView,
    DxRequiredRule,
    Popup,
    DxBox,
    DxButtonItem,
    DxTab,
    ConfirmProjectOnHoldPopup,
  },
  computed: {
    ...mapState('projects', {
      statusses: 'statusses',
    }),
    ...mapGetters('projects', {
      statusIsDeclined: 'getStatusIsDeclined',
    }),
  },
  methods: {
    ...mapActions('projects', {
      fetchData: 'fetch',
    }),
  },
})
export default class ProjectUpdateDialog extends Vue {
  @Prop({ required: true })
  project: any;

  @Prop({ required: false, default: null })
  loggedInEmployee!: Employee | null;

  saving: boolean = false;
  loading: boolean = false;
  showValue: boolean = false;
  enableCheckinAtWork: boolean = false;
  showSiteLabelPopup = false;
  siteLabelForm = {
    name: '',
  };
  siteLabelOptions = {
    dataSource: new DataSource({
      store: new dxCustomStore({
        load: async (loadOptions) => {
          const catalog = this.$store.getters['catalogs/list']('SiteLabels');

          let values = [...catalog.values];

          if (catalog.values && loadOptions && loadOptions.searchOperation === 'contains' && loadOptions.searchValue) {
            values = values.filter((v: string) => v.toLowerCase() === loadOptions.searchValue.toLowerCase() || v.toLowerCase().includes(loadOptions.searchValue.toLowerCase()));
          }

          return values;
        },
        byKey: async (val: any) => {
          return val;
        },
      }),
      paginate: false,
    }),
    searchEnabled: true,
    showClearButton: true,
    onOpened: async (e: any) => {
      await this.siteLabelOptions.dataSource.reload();
    },
  };

  checkinAtWorkDisabled: boolean = false;
  provideSafetyHealthEnvironmentPlanDisabled: boolean = false;
  provideRiskAnalysisDisabled: boolean = false;
  provideInsuranceAttestDisabled: boolean = false;
  provideTechnicalFilesDisabled: boolean = false;
  tunnelGroups: ITunnelGroup[] = [];

  command: ProjectUpdateCommand = new ProjectUpdateCommand({
    warranty: new ProjectWarrantySettings(),
    address: new Address(),
    penaltyClause: false,
    status: 0,
  });

  statusses!: IProjectStatus[];
  fetchData!: any;
  employees: any[] = [];

  projectsClient = new ProjectsClient(undefined, this.$axios);
  templateCompanyPrefixes: TemplateCompanyPrefixDto[] = [];

  async created() {
    await this.loadTunnelGroups();

    this.command.init(this.project);
  }

  async mounted() {
    this.loadEmployees();
    this.fetchData();
    this.setTasks();
    this.getTemplateCompanyPrefixes();
  }

  private setTasks() {
    this.checkinAtWorkDisabled = !this.project.checkinAtWorkTodo;
    this.provideSafetyHealthEnvironmentPlanDisabled = !this.project.provideSafetyHealthEnvironmentPlanTodo;
    this.provideRiskAnalysisDisabled = !this.project.provideRiskAnalysisTodo;
    this.provideInsuranceAttestDisabled = !this.project.provideInsuranceAttestTodo;
    this.provideTechnicalFilesDisabled = !this.project.provideTechnicalFilesTodo;
  }

  reset() {
    this.command = new ProjectUpdateCommand();
  }

  show(project: any) {
    this.command.init(project);
    if (!this.command.warranty) {
      this.command.warranty = new ProjectWarrantySettings();
    }
    if (!this.command.address) {
      this.command.address = new Address();
    }
    setTimeout(() => {
      this.showValue = true;
    }, 300);
  }

  hide() {
    this.showValue = false;
    setTimeout(() => {
      this.reset();
    }, 200);
  }

  calculateName(event: any) {
    if (!this.command.name || this.command.name === '') {
      if (this.command.address && this.command.address.addressline1 !== '' && this.command.address.city !== '') {
        const form: any = this.$refs.projectForm;
        form.instance.updateData('name', `${this.command.address.city}, ${this.command.address.addressline1}`);
      }
    }

    var fieldName: string = event.dataField;
    if (fieldName.includes('Todo')) {
      var field = fieldName.substring(0, fieldName.length - 4);
      if (field == 'checkinAtWork') {
        this.checkinAtWorkDisabled = !this.checkinAtWorkDisabled;
      } else if (field == 'provideRiskAnalysis') {
        this.provideRiskAnalysisDisabled = !this.provideRiskAnalysisDisabled;
      } else if (field == 'provideSafetyHealthEnvironmentPlan') {
        this.provideSafetyHealthEnvironmentPlanDisabled = !this.provideSafetyHealthEnvironmentPlanDisabled;
      } else if (field == 'provideInsuranceAttest') {
        this.provideInsuranceAttestDisabled = !this.provideInsuranceAttestDisabled;
      } else if (field == 'provideTechnicalFiles') {
        this.provideTechnicalFilesDisabled = !this.provideTechnicalFilesDisabled;
      }
    }
  }

  resetSiteLabelPopup() {
    this.showSiteLabelPopup = false;
    this.siteLabelForm.name = '';
  }

  async saveSiteLabel() {
    await this.$store.dispatch('catalogs/addValue', {
      name: 'SiteLabels',
      value: this.siteLabelForm.name,
    });

    const form: any = this.$refs.projectForm;

    form.instance.updateData('siteLabel', this.siteLabelForm.name);

    this.resetSiteLabelPopup();
  }

  async save() {
    try {
      const validationResult = (this.$refs.projectForm as any).instance.validate();
      if (validationResult.isValid) {
        this.saving = true;
        await this.projectsClient.update(this.command.id!, new ProjectUpdateCommand(this.command));
        notificationService.saved();
        this.$emit('saved');
        this.hide();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private async loadEmployees() {
    try {
      this.employees = (await employeesRepository.get()).data;
    } catch {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de medewerkers');
    }
  }

  private async loadTunnelGroups() {
    this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();
  }

  private async getTemplateCompanyPrefixes() {
    this.templateCompanyPrefixes = await this.projectsClient.getTemplateCompanyPrefixes();
  }

  private async confirmProjectOnHold() {
    if (this.project.isOnHold) {
      return;
    }

    const result = await new Promise<boolean>((resolve, reject) => {
      this.confirmProjectOnHoldPopup.show();

      this.confirmProjectOnHoldPopup.$on('save', () => {
        resolve(true);
      });

      this.confirmProjectOnHoldPopup.$on('close', () => {
        resolve(false);
      });
    });

    if (!result) {
      return;
    }

    this.$emit('saved');
    this.hide();
  }

  private async confirmRevertProjectOnHold() {
    if (!this.project.isOnHold) {
      return;
    }

    const result = await new Promise<boolean>((resolve, reject) => {
      this.confirmProjectOnHoldPopup.show();

      this.confirmProjectOnHoldPopup.$on('save', () => {
        resolve(true);
      });

      this.confirmProjectOnHoldPopup.$on('close', () => {
        resolve(false);
      });
    });

    if (!result) {
      return;
    }

    this.$emit('saved');
    this.hide();
  }

  get statusOptions() {
    return { items: this.statusses, valueExpr: 'value', displayExpr: 'name' };
  }

  get paymentOptions() {
    const options = [
      { text: this.$t('objects.projects.TermsOfPaymentOptions.0'), value: 7 },
      { text: this.$t('objects.projects.TermsOfPaymentOptions.1'), value: 14 },
      { text: this.$t('objects.projects.TermsOfPaymentOptions.2'), value: 30 },
    ];
    return {
      dataSource: options,
      valueExpr: 'value',
      displayExpr: 'text',
      searchEnabled: false,
      showClearButton: false,
      showCancelButton: false,
    };
  }

  get projecttypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');
    return {
      items: catalog ? catalog.values : [],
      searchEnabled: true,
    };
  }

  get projectSourceOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectSources');
    return {
      items: catalog ? catalog.values : [],
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get userOptions() {
    this.employees.forEach((employee) => {
      employee.visible = employee.accountEnabled;
    });

    return {
      items: this.employees,
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get zipOptions() {
    const self = this;
    return {
      onChange: async (e: any) => {
        var result = await new ZipClient(undefined, self.$axios).getCityByZip(self.command!.address!.zip!);
        if (result) {
          self.command!.address!.city = result.hoofdgemeente;
        } else {
          self.command!.address!.city = '';
        }
      },
    };
  }

  get editorOptionsCheckinAtWork() {
    return { text: 'Checkin@work', disabled: this.checkinAtWorkDisabled };
  }

  get editorOptionsProvideSafetyHealthEnvironmentPlan() {
    return { text: 'indienen VGM plan', disabled: this.provideSafetyHealthEnvironmentPlanDisabled };
  }

  get editorOptionsProvideRiskAnalysis() {
    return { text: 'indienen risicoanalyse', disabled: this.provideRiskAnalysisDisabled };
  }

  get editorOptionsProvideInsuranceAttest() {
    return { text: 'Attest BA verzekering doorsturen', disabled: this.provideInsuranceAttestDisabled };
  }

  get editorOptionsProvideTechnicalFiles() {
    return { text: 'Technische fiches doorsturen', disabled: this.provideTechnicalFilesDisabled };
  }

  get templateCompanyPrefixOptions() {
    const items = this.templateCompanyPrefixes.map((prefix) => {
      return {
        display: prefix.displayName,
        value: prefix.prefix,
      };
    });

    return {
      items: items,
      displayExpr: 'display',
      valueExpr: 'value',
    };
  }

  get siteLabelButtonOptions() {
    const self = this;

    return {
      text: '+',
      onClick: () => {
        self.showSiteLabelPopup = true;
      },
    };
  }

  get tunnelGroupsOptions() {
    const items = this.tunnelGroups.map((dg) => ({
      value: dg.id,
      text: dg.name,
    }));

    return {
      dataSource: items,
      showClearButton: true,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }

  get buttonOnHoldOptions() {
    const self = this;

    return {
      text: this.$t('objects.projects.PutProjectOnHold'),
      type: 'danger',
      onClick() {
        self.confirmProjectOnHold();
      },
    };
  }

  get buttonRevertOnHoldOptions() {
    const self = this;

    return {
      text: this.$t('objects.projects.RevertPutProjectOnHold'),
      type: 'success',
      onClick() {
        self.confirmRevertProjectOnHold();
      },
    };
  }

  get confirmProjectOnHoldPopup() {
    return this.$refs.confirmProjectOnHold as ConfirmProjectOnHoldPopup;
  }

  get confirmRevertProjectOnHoldPopup() {
    return this.$refs.confirmRevertProjectOnHold as ConfirmRevertProjectOnHoldPopup;
  }

  get currentUserCanToggleProjectOnHold(): boolean {
    return this.loggedInEmployee?.canToggleProjectsOnHold ?? false;
  }

  get billingTypeOptions() {
    const items = [
      {
        value: BillingType.AdvanceInvoice,
        text: 'Voorschotfactuur'
      },
      {
        value: BillingType.ProgressStatement,
        text: 'Vorderstaat'
      }
    ];

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }
}
